(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/marketplace/components/welcome/assets/javascripts/welcome-retail.js') >= 0) return;  svs.modules.push('/modules/marketplace/components/welcome/assets/javascripts/welcome-retail.js');
'use strict';

const {
  Button
} = svs.ui;
const {
  clx
} = svs.components.lbUtils;
const {
  Link
} = ReactRouterDOM;
const {
  Hero
} = svs.components.marketplace.hero;
const {
  getOptimalWidth
} = svs.utils;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const WelcomeRetail = _ref => {
  var _svs$marketplace$data, _svs$marketplace$data2, _svs$marketplace$data3, _svs$marketplace$data4, _svs$marketplace$data5, _svs$marketplace$data6;
  let {
    linkTo
  } = _ref;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const availableWidths = (_svs$marketplace$data = svs.marketplace.data.heroData) === null || _svs$marketplace$data === void 0 ? void 0 : (_svs$marketplace$data2 = _svs$marketplace$data.retailHero) === null || _svs$marketplace$data2 === void 0 ? void 0 : _svs$marketplace$data2.availableWidths;
  const optimalWidth = getOptimalWidth(availableWidths, 1024);
  const imageUrl = (_svs$marketplace$data3 = svs.marketplace.data.heroData) === null || _svs$marketplace$data3 === void 0 ? void 0 : (_svs$marketplace$data4 = _svs$marketplace$data3.retailHero) === null || _svs$marketplace$data4 === void 0 ? void 0 : _svs$marketplace$data4.imageUrl.replace('{width}', optimalWidth);
  const button = React.createElement(Button, {
    className: "qa-find-team",
    inverted: true
  }, React.createElement(Link, {
    className: "qa-find-team-link",
    to: linkTo
  }, "Hitta andelsspel"));
  const hasHeroData = Boolean(svs.marketplace.data.heroData && svs.marketplace.data.heroData.retailHero);
  return React.createElement("div", {
    className: "bg-red-100 marketplace-full-width padding-bottom-2 padding-top-3",
    "data-testid": "qa-mkp-retail-welcome"
  }, hasHeroData ? React.createElement(Hero, {
    className: clx('team-list-hero', {
      'marketplace-hero-no-image': !imageUrl
    }),
    height: isSmall ? 350 : 500,
    horizontal: "center",
    imageUrl: "".concat(svs.core.config.data.svsconfig.cdn2).concat(imageUrl),
    vertical: "center"
  }, React.createElement("div", {
    className: "marketplace-hero-inner-content"
  }, React.createElement("h2", {
    className: "marketplace-hero-title"
  }, (_svs$marketplace$data5 = svs.marketplace.data.heroData) === null || _svs$marketplace$data5 === void 0 ? void 0 : (_svs$marketplace$data6 = _svs$marketplace$data5.retailHero) === null || _svs$marketplace$data6 === void 0 ? void 0 : _svs$marketplace$data6.title), React.createElement("div", {
    className: "marketplace-hero-button-container"
  }, React.createElement(Button, {
    className: "qa-marketplace-create-team",
    size: 300
  }, "Logga in")))) : null, React.createElement("div", {
    className: "f-center welcome-cramped-container"
  }, React.createElement("h2", {
    className: "f-900 margin-top-1"
  }, "Spela hos ett ombud!"), button));
};
setGlobal('svs.marketplace.components.welcome.WelcomeRetail', WelcomeRetail);

 })(window);